module.exports = __webpack_public_path__ + "img/greeting-wrapper.54c9d052.jpg";